import React from 'react';
import Button from '../../Shared/UI/Button/components/Button';

import {
  useProfileState,
  useProfileActions
} from './ProfileContext';

import { disassociateSkillWithAuthenticatedUser } from './restApi';

import styles from './ProfileUserSkill.module.scss';

const ProfileUserSkill = ({ skill }) => {
  const state = useProfileState();
  const { onResponse, onError } = useProfileActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  return state.user?.isAuthenticatedUser ? (
    <div key={skill.id} className={styles.userSkillWithRemoveBtn}>
      <p className={styles.displayedSkillNameWithRemoveBtn}>{skill.name}</p>
      <div className={styles.removeUserSkillBtnContainer}>
        <Button
          variant="primary"
          size='minimal'
          onClick={() => {
            disassociateSkillWithAuthenticatedUser(({
              body: {
                skillId: skill.id,
                authenticityToken,
              },
              onResponse,
              onError,
            }))
          }}
        >
          &#10005;
        </Button>
      </div>
    </div>
  ) : (
    <div key={skill.id} className={styles.userSkillWithoutRemoveBtn}>
      <p className={styles.displayedSkillNameWithoutRemoveBtn}>{skill.name}</p>
    </div>
  );
};

export default ProfileUserSkill;
